module.exports = __webpack_public_path__ + "static/media/charlie.e340c1a1.jpg";